import type {CSSProperties} from 'react';
import {WEDGE_RAIL_PAD} from '@territory/tokens';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgePadAreaVariant = 'wedge-pad-area' | 'wedge-pad-area-mobile';

export const isWedgePadAreaVariant = (variant: unknown): variant is WedgePadAreaVariant =>
  variant === 'wedge-pad-area' || variant === 'wedge-pad-area-mobile';

/* Released writing surface of the rail notepad (the Notes pad of the Brief when the journal is off): one bare native textarea at full width and
   border-box on the surface fill with the `--label` ink, a 1px `--separator-bold` border, a 14px radius, 14px by 16px padding, no resize,
   hidden overflow, no outline, the soft rail pad shadow (WEDGE_RAIL_PAD.shadow), the Wedge font at line height 1.55 and a scroll margin that
   keeps the caret 12px above the keyboard height. The desktop look is 130px tall at least with 13.5px type; the phone look is 148px with 16px
   type, which keeps iOS from zooming the focused field. The caller grows the field by writing its height and overflow on the element, owns the
   value, the handlers, the ref and the placeholder, and passes no row count (the source has none). Each color reads the exact legacy role, so
   the shipped ink rules keep matching. */
export function wedgePadAreaStyle(variant: WedgePadAreaVariant): CSSProperties {
  const r = wedgeExactRole, phone = variant === 'wedge-pad-area-mobile';
  return {
    scrollMarginBottom: 'calc(var(--rv-kb-h, 0px) + 12px)', width: '100%', minHeight: phone ? 148 : 130, resize: 'none', overflow: 'hidden', boxSizing: 'border-box',
    padding: '14px 16px', borderRadius: 14, background: r('surface'), color: r('label'), border: `1px solid ${r('separatorBold')}`, outline: 'none',
    boxShadow: WEDGE_RAIL_PAD.shadow, fontFamily: r('font'), fontSize: phone ? 16 : 13.5, lineHeight: 1.55,
  };
}
